import { CarrierDocumentVersion } from "./carrier-document-version";

export class CarrierDocument {
    documentId: string;
    title: string;
    carrierGuid: string;
    documentType: string;
    documentTypeCode: string;
    documentTypeId: number;
    versions: Array<CarrierDocumentVersion> = [];
    isLinked: boolean;
}